

import { declareVueComponent } from '/vodalys/vvuejs'


import HeaderExtraComponent from './components/HeaderExtraComponent.vue'
declareVueComponent('HeaderExtraComponent', HeaderExtraComponent)

import VProject17BarLeft from './components/VProject17BarLeft.vue'
declareVueComponent('VProject17BarLeft', VProject17BarLeft)

